/*
 * Module for the response editor
 */

define([
  "marionette",
  "backbone",
  "i18n/i18n",
  "messaging/messenger",
  "modules/shared/ckeditor5/ckEditor5Module",
  "modules/shared/ckeditor5/cloud/cloudModel",
  "modules/topicsSplit/topic/topicResponseDeleteCollabDataModal/topicResponseDeleteCollabDataModalView",
], function (
  Marionette,
  Backbone,
  i18next,
  Messenger,
  Es6CkEditor5Module,
  CkEditorCloudModel,
  TopicResponseDeleteCollabDataModalView,
) {
  "use strict";

  const CkEditor5Module = Es6CkEditor5Module.default || Es6CkEditor5Module;

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicResponseDeleteCollabDataModal";
    },
    show: function (conversationObject) {
      this.selectedTouchPoint = conversationObject.selectedTouchPoint;
      this.selectedLanguage = conversationObject.selectedLanguage;
      this.conversation = conversationObject.node;
      this.responseTemplate = conversationObject.node.findResponseTemplate(
        this.selectedTouchPoint,
        this.selectedLanguage,
      );

      if (!this.responseTemplate) {
        throw error("Could not find response template for selected touchpoint and locale");
      }

      this.view =
        new TopicResponseDeleteCollabDataModalView.topicResponseDeleteCollabDataModalView();
      this.view.on("delete:data", this._deleteCollabData, this);
      this.view.on("cancel", () => Messenger.vent.trigger("close:modal"));

      this.htmlEditor = this.addSubModule(
        new CkEditor5Module.ckEditor5Module({ namespace: this.name, region: this.view.htmlEditor }),
      );

      this.showRegion(this.view, { loading: true });
    },
    _deleteCollabData: function () {
      this.view.disableDeleteButton();
      Messenger.vent.trigger("show:saving:display");
      this.responseTemplate
        .deleteCollabData()
        .catch((e) => {
          console.error("Failed to delete response collaboration data", e);
          Messenger.okDialog(i18next.t("topic.response.deleteCollabData.error"));
        })
        .finally(() => {
          Messenger.vent.trigger("close:saving:display");
          Messenger.vent.trigger("close:modal");
        });
    },
  });
});
